let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cOnF4")).then(() => parcelRequire('ejP4E'));